import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-container.html';

/**
 * <ns-container></ns-container>
 */
export class NsContainer extends PolymerElement {
    static get is() { return 'ns-container'; }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
    }

    static get properties() {
        return {
            contained: Boolean,
            direction: {
                type: String,
                value: "row"
            },
            justifycontent: {
                type: String,
                value: "center"
            },
            alignitems: {
                type: String,
                value: "flex-start"
            },
            aligncontent: {
                type: String,
                value: "center"
            },
            alignself: {
                type: String,
                value: "flex-start"
            },
            flexgrow: {
                type: String,
                value: "all"
            },
            height: {
                type: String,
                value: "100%"
            },
            minheight: {
                type: String,
                value: "inherit"
            },
            margintop: {
                type: Number,
                value: 0
            },
            marginbottom: {
                type: Number,
                value: 0
            },
            paddingtop: {
                type: Number,
                value: 0
            },
            paddingbottom: {
                type: Number,
                value: 0
            },
            paddingleft: {
                type: Number,
                value: 0
            },
            paddingright: {
                type: Number,
                value: 0
            },
            gutter: {
                type: Number,
                value: 0
            },
            width: {
                type: String,
                value: "auto",
                notify: true
            },
            hidden: String,
            reversebreakpoint: Boolean,
            flexwrap: Boolean,
            inlineflex: Boolean,
            tabletdirection: String,
            desktopdirection: String
        }
    }
    ready() {
        super.ready();
    }
}

window.customElements.define(NsContainer.is, NsContainer);